import {atomWithReset} from 'jotai/utils'
import {IGameStartedMessage} from '../../../types/ws.types'

export const gameStartedState = atomWithReset<IGameStartedMessage | null>(null)
